import ApiTableSpanRow from './ApiTableSpanRow'

import type {PropertyDescriptions} from '../apiList'

type Props = {
    data: PropertyDescriptions
}

export default function ApiTable({data}: Props) {
    return <table className='api-table'>
        <tbody>
            {Object.entries(data).map(([mainKey, {value: mainValue, type: mainType}]) =>
                <ApiTableSpanRow key={mainKey} value={mainValue} type={mainType} title={mainKey}/>
            )}
        </tbody>
    </table>
}
